var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayergrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180206",
    "data-name": "Group 180206",
    transform: "translate(-47 -279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146864",
    "data-name": "Rectangle 146864",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(47 279)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Animation_Timeline_177468",
    "data-name": "noun_Animation Timeline_177468",
    transform: "translate(40.016 270.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7943",
    "data-name": "Group 7943",
    transform: "translate(14.985 16.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5995",
    "data-name": "Path 5995",
    d: "M14.985,44.735h5.641v-.8H19.447V42.748h1.179v-.8H15.75V37.58h4.876v-.795H19.447V35.658h1.179v-.8H14.985Zm2.55-9.077h1.147v1.127H17.535Zm-1.785,0h1.02v1.127H15.75Zm1.785,7.089h1.147V43.94H17.535Zm-1.785,0h1.02V43.94H15.75Z",
    transform: "translate(-14.985 -30.457)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5996",
    "data-name": "Path 5996",
    d: "M46.373,34.863v.8h1.116v1.127H46.373v.8h4.972v4.373H46.373v.8h1.116V43.94H46.373v.8H55.2V41.953H52.11V37.58H55.2V34.863ZM49.4,36.785H48.254V35.658H49.4Zm1.913,0H50.166V35.658h1.147ZM49.4,43.94H48.254V42.747H49.4Zm1.913,0H50.166V42.747h1.147Zm2.677-1.192h.446V43.94h-.446Zm-.765,0V43.94H52.11V42.747Zm0-5.963H52.11V35.658h1.116Zm1.211,0h-.446V35.658h.446Z",
    transform: "translate(-39.202 -30.457)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5997",
    "data-name": "Path 5997",
    d: "M38.441,17.106a.809.809,0,0,0-.224-.562.747.747,0,0,0-.541-.233H35.349a.748.748,0,0,0-.541.233.81.81,0,0,0-.224.562v1l1.546,1.013V32.311H36.9V19.122l1.546-1.013v-1Z",
    transform: "translate(-30.106 -16.311)",
    fill: "#1e1e1e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayergrey);
export default __webpack_public_path__ + "static/media/Layergrey.67b5c350a5892b62a4546587b31632ab.svg";
export { ForwardRef as ReactComponent };